import React from 'react';
import { AlertTriangleIcon, CheckIcon } from 'lucide-react';
export interface PreflightItem {
  label: string;
  ready: boolean;
}
interface PreflightChecklistProps {
  items: PreflightItem[];
}
export function PreflightChecklist({
  items
}: PreflightChecklistProps) {
  return <ul className="flex flex-wrap items-center gap-x-5 gap-y-2" data-id="element-141" data-mp="2v1b3jyfekpmd">
      {items.map(item => <li key={item.label} className={`flex items-center gap-1.5 text-sm ${item.ready ? 'text-slate-600' : 'font-medium text-amber-700'}`} data-id="element-142" data-mp="1xdixsg2a4g36">
          {item.ready ? <CheckIcon aria-hidden="true" className="h-4 w-4 text-emerald-600" data-id="element-143" data-mp="27bgulry7fl7e" /> : <AlertTriangleIcon aria-hidden="true" className="h-4 w-4 text-amber-500" data-id="element-144" data-mp="2bdtq7nj8m2qg" />}
          {item.label}
        </li>)}
    </ul>;
}